import styled from "styled-components";
import { MainHeading, MainHeadingColor, MainSectionWrapper } from "../../../../components/01_config/MainStyles";

const Wrapper = styled(MainSectionWrapper)`

`

const Heading = styled(MainHeading)`

`

const HeadingColor = styled(MainHeadingColor)`
text-align: center;
`

export { Wrapper, Heading, HeadingColor }